import axios from 'axios';
import Cookies from 'js-cookie';

const getDataFromAPI = async (url, paramsObj, headersObj, mapped) => {
  url = `${process.env.REACT_APP_API_URL}` + url;
  // url = `http://samlite.nubaxdatalabs.com/` + url
  const tokenid = Cookies.get('authUser');

  let headers = headersObj || { tokenid };

  try {
    const response = await axios.get(url, { headers });
    return response.data
  } catch (error) {
    return error;
  }
};

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { getDataFromAPI };
